import {invalidateFilterData} from '../../services/filterData';
import ActionTypes from  "./types";
import axios from "axios";
import { errorLogger } from "../../services/errorLogger";
import { setAlert } from "./alert";
import { BASE_URL } from "../../utils/constants";

const getTempData = (data, cb) => (dispatch) => {
    return axios.get(`${BASE_URL}/api/data/mapping`, {params: data})
            .then(({data}) => {
                dispatch({type: ActionTypes.GET_TEMP_DATA});
                if (data?.success){
                    cb(data?.tempData)
                }
            })
            .catch(
                (err) => errorLogger(
                            dispatch, 
                            err, 
                            ActionTypes.GET_TEMP_DATA_FAIL
                        )
            );
}

const getTempItemData = (id, data, cb) => (dispatch) => {
    return axios.get(`${BASE_URL}/api/data/mapping/${id}`, {params: data})
            .then(({data}) => {
                dispatch({type: ActionTypes.GET_TEMP_ITEM});
                if (data?.success){
                    cb(data?.tempDataItem)
                }
            })
            .catch(
                (err) => errorLogger(
                            dispatch, 
                            err, 
                            ActionTypes.GET_TEMP_ITEM_FAIL
                        )
            );
}

const getResources = (cb) => (dispatch) => {
    return axios.get(`${BASE_URL}/api/data/resources`)
            .then(({data}) => {
                dispatch({type: ActionTypes.GET_RESOURCES});
                if (data?.success){
                    cb(data?.data)
                }
            })
            .catch(
                (err) => errorLogger(
                            dispatch, 
                            err, 
                            ActionTypes.GET_RESOURCES_FAIL
                        )
            );
}

const addPublisher = (data) => (dispatch) => {
    return axios.post(`${BASE_URL}/api/data/publishers`, {...data})
            .then(({data}) => {
                dispatch({type: ActionTypes.ADD_PUBLISHER});
                if (data?.success){
                    invalidateFilterData();
                    dispatch(setAlert(data?.message, 'success'));
                }
            })
            .catch(
                (err) => errorLogger(
                            dispatch, 
                            err, 
                            ActionTypes.ADD_PUBLISHER_FAIL
                        )
            );
}

const deletePublisher = (id) => (dispatch) => {
    return axios.delete(`${BASE_URL}/api/data/publishers/${id}`)
            .then(({data}) => {
                dispatch({type: ActionTypes.DELETE_PUBLISHER});
                if (data?.success){
                    invalidateFilterData();
                    dispatch(setAlert(data?.message, 'success'));
                }
            })
            .catch(
                (err) => errorLogger(
                            dispatch, 
                            err, 
                            ActionTypes.DELETE_PUBLISHER_FAIL
                        )
            );
}

const addPlatform = (data) => (dispatch) => {
    return axios.post(`${BASE_URL}/api/data/platforms`, {...data})
            .then(({data}) => {
                dispatch({type: ActionTypes.ADD_PLATFORM});
                if (data?.success){
                    invalidateFilterData();
                    dispatch(setAlert(data?.message, 'success'));
                }
            })
            .catch(
                (err) => errorLogger(
                            dispatch, 
                            err, 
                            ActionTypes.ADD_PLATFORM_FAIL
                        )
            );
}

const editPlatform = (id, data) => (dispatch) => {
    return axios.put(`${BASE_URL}/api/data/platforms/${id}`, {...data})
            .then(({data}) => {
                dispatch({type: ActionTypes.EDIT_PLATFORM});
                if (data?.success){
                    invalidateFilterData();
                    dispatch(setAlert(data?.message, 'success'));
                }
            })
            .catch(
                (err) => errorLogger(
                            dispatch, 
                            err, 
                            ActionTypes.EDIT_PLATFORM_FAIL
                        )
            );
}

const deletePlatform = (id) => (dispatch) => {
    return axios.delete(`${BASE_URL}/api/data/platforms/${id}`)
            .then(({data}) => {
                dispatch({type: ActionTypes.DELETE_PLATFORM});
                if (data?.success){
                    invalidateFilterData();
                    dispatch(setAlert(data?.message, 'success'));
                }
            })
            .catch(
                (err) => errorLogger(
                            dispatch, 
                            err, 
                            ActionTypes.DELETE_PLATFORM_FAIL
                        )
            );
}

const addWebsite = (data) => (dispatch) => {
    return axios.post(`${BASE_URL}/api/data/websites`, {...data})
            .then(({data}) => {
                dispatch({type: ActionTypes.ADD_WEBSITE});
                if (data?.success){
                    invalidateFilterData();
                    dispatch(setAlert(data?.message, 'success'));
                }
            })
            .catch(
                (err) => errorLogger(
                            dispatch, 
                            err, 
                            ActionTypes.ADD_WEBSITE_FAIL
                        )
            );
}

const deleteWebsite = (id) => (dispatch) => {
    return axios.delete(`${BASE_URL}/api/data/websites/${id}`)
            .then(({data}) => {
                dispatch({type: ActionTypes.DELETE_WEBSITE});
                if (data?.success){
                    invalidateFilterData();
                    dispatch(setAlert(data?.message, 'success'));
                }
            })
            .catch(
                (err) => errorLogger(
                            dispatch, 
                            err, 
                            ActionTypes.DELETE_WEBSITE_FAIL
                        )
            );
}

const addRule = (data) => (dispatch) => {
    return axios.post(`${BASE_URL}/api/data/rules`, {...data})
            .then(({data}) => {
                dispatch({type: ActionTypes.ADD_RULE});
                if (data?.success){
                    invalidateFilterData();
                    dispatch(setAlert(data?.message, 'success'));
                }
            })
            .catch(
                (err) => errorLogger(
                            dispatch, 
                            err, 
                            ActionTypes.ADD_RULE_FAIL
                        )
            );
}

const deleteRule = (id) => (dispatch) => {
    return axios.delete(`${BASE_URL}/api/data/rules/${id}`)
            .then(({data}) => {
                dispatch({type: ActionTypes.DELETE_RULE});
                if (data?.success){
                    invalidateFilterData();
                    dispatch(setAlert(data?.message, 'success'));
                }
            })
            .catch(
                (err) => errorLogger(
                            dispatch, 
                            err, 
                            ActionTypes.DELETE_RULE_FAIL
                        )
            );
}

const mapItem = (id, data, partition) => (dispatch) => {
    return axios.post(`${BASE_URL}/api/data/mapping/${id}`, {...data, partition})
            .then(({data}) => {
                dispatch({type: ActionTypes.MAP_ITEM});
                if (data?.success){
                    invalidateFilterData();
                    dispatch(setAlert(data?.message, 'success'));
                }
            })
            .catch(
                (err) => errorLogger(
                            dispatch, 
                            err, 
                            ActionTypes.MAP_ITEM_FAIL
                        )
            );
}

const mapItemsBulk = (id, data, partition) => (dispatch) => {
    return axios.post(`${BASE_URL}/api/data/mapping/bulk/${id}`, {...data, partition})
            .then(({data}) => {
                dispatch({type: ActionTypes.MAP_ITEMS_BULK});
                if (data?.success){
                    invalidateFilterData();
                    dispatch(setAlert(data?.message, 'success'));
                }
            })
            .catch(
                (err) => errorLogger(
                            dispatch, 
                            err, 
                            ActionTypes.MAP_ITEMS_BULK_FAIL
                        )
            );
}

const getAvailability = (cb) => (dispatch) => {
    return axios.get(`${BASE_URL}/api/data/availability`)
            .then(({data}) => {
                dispatch({type: ActionTypes.GET_DATA_AVAILABILITY});
                if (data?.success){
                    cb(data?.data)
                }
            })
            .catch(
                (err) => errorLogger(
                            dispatch, 
                            err, 
                            ActionTypes.GET_DATA_AVAILABILITY_FAIL
                        )
            );
}

const getCrons = (cb) => (dispatch) => {
    return axios.get(`${BASE_URL}/api/data/crons`)
            .then(({data}) => {
                dispatch({type: ActionTypes.GET_CRONS});
                if (data?.success){
                    cb(data?.data)
                }
            })
            .catch(
                (err) => errorLogger(
                            dispatch, 
                            err, 
                            ActionTypes.GET_CRONS_FAILS
                        )
            );
}

export {
    getTempData,
    getTempItemData,
    getResources,
    addPublisher,
    addWebsite,
    addRule,
    deletePublisher,
    deleteWebsite,
    deleteRule,
    mapItem,
    mapItemsBulk,
    getAvailability,
    getCrons,
    addPlatform,
    deletePlatform,
    editPlatform
}